import i18n from "@/i18n";
import {
  IContractProductProvider,
  IProvisioningProvider
} from "@/models/providers/contractProduct";
import { IMenuRoute } from "@/models/routes";

const isActive: IMenuRoute["isActive"] = (currentRoute, isActive) => {
  if ((currentRoute.name || "").match(/__upmind(Cancelled|Active)/g))
    return false;
  return isActive;
};

export function UpmindClientProductsTabigation() {
  return [
    {
      label: i18n.t("_.active"),
      to: {
        name: "admin__upmindActiveProducts"
      }
    },
    {
      label: i18n.t("_.cancelled"),
      to: {
        name: "admin__upmindCancelledProducts"
      }
    },
    {
      isActive,
      label: i18n.t("_.all"),
      to: {
        name: "admin__upmindAllProducts"
      }
    }
  ];
}

export function UpmindClientSubscriptionsTabigation() {
  return [
    {
      label: i18n.t("_.active"),
      to: {
        name: "admin__upmindActiveSubscriptions"
      }
    },
    {
      label: i18n.t("_.cancelled"),
      to: {
        name: "admin__upmindCancelledSubscriptions"
      }
    },
    {
      isActive,
      label: i18n.t("_.all"),
      to: {
        name: "admin__upmindAllSubscriptions"
      }
    }
  ];
}

export function UpmindClientOneTimePurchasesTabigation() {
  return [
    {
      label: i18n.t("_.active"),
      to: {
        name: "admin__upmindActiveOneTimePurchases"
      }
    },
    {
      label: i18n.t("_.cancelled"),
      to: {
        name: "admin__upmindCancelledOneTimePurchases"
      }
    },
    {
      isActive,
      label: i18n.t("_.all"),
      to: {
        name: "admin__upmindAllOneTimePurchases"
      }
    }
  ];
}

export function UpmindClientCProdTabigation({
  $cProdData,
  $cProdProvData
}: {
  $cProdData: IContractProductProvider;
  $cProdProvData: IProvisioningProvider;
}) {
  return [
    {
      label: i18n.t("_.overview"),
      to: {
        name: `admin__upmindClientCProdOverview`
      }
    },
    {
      label: i18n.t("_.invoices"),
      to: {
        name: `admin__upmindClientCProdInvoices`
      }
    },
    {
      label: i18n.t("_.credit_notes"),
      to: {
        name: `admin__upmindClientCProdCreditNotes`
      }
    },
    {
      label: i18n.t("_.manage"),
      to: {
        name: `admin__upmindClientCProdProvisioning`
      },
      if: () => {
        return $cProdProvData.canManageProvisioning;
      }
    },
    {
      label: i18n.t("_.settings"),
      to: {
        name: `admin__upmindClientCProdSettings`
      },
      if: () => {
        return $cProdData.canModifySettings;
      }
    }
  ];
}
